import { render, staticRenderFns } from "./ImportList.vue?vue&type=template&id=a2b9a288&"
import script from "./ImportList.vue?vue&type=script&lang=js&"
export * from "./ImportList.vue?vue&type=script&lang=js&"
import style0 from "./ImportList.vue?vue&type=style&index=0&id=a2b9a288&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports